import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import enAdmin from './en-admin.json';
import enAutomatedMarketing from './en-automated-marketing.json';
import enClient from './en-client.json';
import enCommunication from './en-communication.json';
import enCoupon from './en-coupon.json';
import enCrm from './en-crm.json';
import enForms from './en-forms.json';
import enGames from './en-games.json';
import enListCategory from './en-list-category.json';
import enLoyalty from './en-loyalty.json';
import enMobile from './en-mobile.json';
import enMyBrands from './en-my-brands.json';
import enNotification from './en-notification.json';
import enOwnersManagement from './en-owners-management.json';
import enPos from './en-pos.json';
import enProno from './en-prono.json';
import enReceipt from './en-receipt.json';
import enReferral from './en-referral.json';
import enScanner from './en-scanner.json';
import enStore from './en-store.json';
import enTablet from './en-tablet.json';
import enVisibility from './en-visibility.json';
import fr from './fr.json';
import frAdmin from './fr-admin.json';
import frAutomatedMarketing from './fr-automated-marketing.json';
import frClient from './fr-client.json';
import frCommunication from './fr-communication.json';
import frCoupon from './fr-coupon.json';
import frCrm from './fr-crm.json';
import frForms from './fr-forms.json';
import frGames from './fr-games.json';
import frListCategory from './fr-list-category.json';
import frLoyalty from './fr-loyalty.json';
import frMobile from './fr-mobile.json';
import frMyBrands from './fr-my-brands.json';
import frNotification from './fr-notification.json';
import frOwnersManagement from './fr-owners-management.json';
import frPos from './fr-pos.json';
import frProno from './fr-prono.json';
import frReceipt from './fr-receipt.json';
import frReferral from './fr-referral.json';
import frScanner from './fr-scanner.json';
import frStore from './fr-store.json';
import frTablet from './fr-tablet.json';
import frVisibility from './fr-visibility.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: en,
        automatedMarketing: enAutomatedMarketing,
        loyalty: enLoyalty,
        admin: enAdmin,
        store: enStore,
        ownersManagement: enOwnersManagement,
        myBrands: enMyBrands,
        client: enClient,
        coupon: enCoupon,
        communication: enCommunication,
        pos: enPos,
        scanner: enScanner,
        mobile: enMobile,
        tablet: enTablet,
        crm: enCrm,
        listCategory: enListCategory,
        games: enGames,
        prono: enProno,
        forms: enForms,
        notification: enNotification,
        receipt: enReceipt,
        referral: enReferral,
        visibility: enVisibility,
      },
      fr: {
        translation: fr,
        automatedMarketing: frAutomatedMarketing,
        loyalty: frLoyalty,
        admin: frAdmin,
        store: frStore,
        ownersManagement: frOwnersManagement,
        myBrands: frMyBrands,
        client: frClient,
        coupon: frCoupon,
        communication: frCommunication,
        pos: frPos,
        scanner: frScanner,
        mobile: frMobile,
        tablet: frTablet,
        crm: frCrm,
        listCategory: frListCategory,
        games: frGames,
        prono: frProno,
        forms: frForms,
        notification: frNotification,
        receipt: frReceipt,
        referral: frReferral,
        visibility: frVisibility,
      },
    },
    lng: 'en',

    keySeparator: '.',
    nsSeparator: '|',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export const isUS = () => {
  return i18n.language === 'en';
};

export default i18n;
